export enum RequestsScreenNames {
  MAIN = 'requests',
  MY_REQUESTS = 'my-requests',
  ADD_REQUEST = 'add-request',
}
